import moment from "moment";
import reportActions from "../actions/reportCampaignAction";
import eventAdvertise from "../actions/eventAdvertise";
import helpersTime from "../../helpers/time";
import typeCampaignCategorySelected from "../../component/sections/report/TypeCampaignCategorySelected";
import constantsReportCampaign from "../../component/sections/report/constants/reportCampaign";
import activeChart from "../actions/activeChart";
import separationActive from "../../component/sections/report/SeparationActive";
import ReportData from "../../component/sections/report/ReportData";

const mainState = {
  which_type_select: constantsReportCampaign.whichTypeSelect.TYPE_CAMPAIGNS,
  campaign_type_category_selected: typeCampaignCategorySelected.ALL,
  campaign_id_selected: 0,

  count_active_campaign: 0,
  count_active_advertise: 0,
  status_campaign: "",
  count_click: 0,
  count_view: 0,
  time_view_campaign: 0,

  which_separation_active: separationActive.PUBLISHER,

  date_from: helpersTime.addStartTime(helpersTime.getLastDayDate(1)),
  date_to: helpersTime.addStartTime(moment().format("YYYY-MM-DD")),
  active_chart: activeChart.LINE_SIMPLE,

  event_data_chart: eventAdvertise.eventAdvertiseString.VIEW,

  data_chart: [],
  data_chart_separation: {},

  price: 0,
};

const getCountDayBetweenTwoDates = (dateFrom, dateTo) => {
  return helpersTime.getDifferentDates(dateFrom, dateTo);
};

const generateDataSeparationTime = (dateFrom, dateTo, view) => {
  const countDayBetweenTwoDates = getCountDayBetweenTwoDates(dateFrom, dateTo);
  const dataSeparationTime = {};
  dataSeparationTime[dateFrom] = {
    view: view,
  };

  for (let counter = 1; counter <= countDayBetweenTwoDates; counter++) {
    if (getRandomNumber(2)) {
      view = view + getRandomNumber(30);
    } else {
      view = view - getRandomNumber(30);
    }
    dataSeparationTime[
      helpersTime.addDate(dateFrom, counter, "d").split(" ")[0]
    ] = {
      view: view,
    };
  }
  return dataSeparationTime;
};

const getCountViewCampaign = (dateForm, dateTo, report) => {
  const countDayBetweenTwoDates = getCountDayBetweenTwoDates(dateForm, dateTo);
  return report.count_view_each_hour * countDayBetweenTwoDates * 24;
};

const getCostCampaign = (dateForm, dateTo, costEachDay) => {
  const countDayBetweenTwoDates = getCountDayBetweenTwoDates(dateForm, dateTo);
  return countDayBetweenTwoDates * costEachDay;
};

const getRandomNumber = (range) => {
  return Math.floor(Math.random() * range);
};

const generateDataSeparationTimeEachHour = (view) => {
  return {
    "00:00:00-00:59:59": view,
    "01:00:00-01:59:59": view + getRandomNumber(10),
    "02:00:00-02:59:59": view,
    "03:00:00-03:59:59": view + getRandomNumber(10),
    "04:00:00-04:59:59": view - getRandomNumber(10),
    "05:00:00-05:59:59": view + getRandomNumber(10),
    "06:00:00-06:59:59": view - getRandomNumber(10),
    "07:00:00-07:59:59": view,
    "08:00:00-08:59:59": view + getRandomNumber(10),
    "09:00:00-09:59:59": view,
    "10:00:00-10:59:59": view - getRandomNumber(10),
    "11:00:00-11:59:59": view,
    "12:00:00-12:59:59": view + getRandomNumber(10),
    "13:00:00-13:59:59": view,
    "14:00:00-14:59:59": view - getRandomNumber(10),
    "15:00:00-15:59:59": view + getRandomNumber(10),
    "16:00:00-16:59:59": view,
    "17:00:00-17:59:59": view + getRandomNumber(10),
    "18:00:00-18:59:59": view,
    "19:00:00-19:59:59": view - getRandomNumber(10),
    "20:00:00-20:59:59": view,
    "21:00:00-21:59:59": view - getRandomNumber(10),
    "22:00:00-22:59:59": view + getRandomNumber(10),
    "23:00:00-23:59:59": view - getRandomNumber(10),
  };
};

const main = (state = mainState, action) => {
  let newState = state;
  let campaignID;
  let dateForm;
  let dateTo;
  let report;
  let countDayBetweenTwoDates;
  let countView;
  let allCampaignCountView = 0;
  let allCampaignTimeView = 0;
  let allCampaignCost = 0;
  let dataChartSeparation;
  let dataChart = {};
  switch (action.type) {
    case reportActions.GET_CAMPAIGN_REPORT_WITH_CAMPAIGN_NAME:
      campaignID = action.payload.campaign_id;
      report = ReportData.filter((campaign) => campaign.id == campaignID);
      report = report[0];
      countView = getCountViewCampaign(
        action.payload.date_from,
        action.payload.date_to,
        report
      );

      newState = {
        ...state,
        campaign_id_selected: campaignID,
        status_campaign: report.status,
        which_type_select: constantsReportCampaign.whichTypeSelect.CAMPAIGN,

        count_view: countView,
        time_view_campaign: countView * report.max_time_duration_banner,
        price: getCostCampaign(
          action.payload.date_from,
          action.payload.date_to,
          report.price_each_day
        ),
      };
      break;

    case reportActions.GET_ALL_CAMPAIGN_REPORT_LINE_CHART:
      dateForm = action.payload.date_from;
      dateTo = action.payload.date_to;
      countDayBetweenTwoDates = getCountDayBetweenTwoDates(dateForm, dateTo);
      if (countDayBetweenTwoDates == 1) {
        ReportData.forEach((report) => {
          dataChart = generateDataSeparationTimeEachHour(
            report.count_view_each_hour
          );
        });
      } else {
        ReportData.forEach((report) => {
          dataChart = generateDataSeparationTime(
            dateForm.split(" ")[0],
            dateTo.split(" ")[0],
            report.count_view_each_hour * 24
          );
          for (const key in dataChart) {
            dataChart[key] = dataChart[key].view;
          }
        });
      }

      newState = {
        ...state,
        active_chart:
          helpersTime.getDifferentDates(
            action.payload.date_from,
            action.payload.date_to
          ) == 1
            ? activeChart.LINE_SIMPLE
            : activeChart.BAR,
        data_chart: dataChart,
      };
      break;

    case reportActions.GET_CAMPAIGN_REPORT_LINE_CHART:
      campaignID = action.payload.campaign_id;
      report = ReportData.filter((campaign) => campaign.id == campaignID);
      report = report[0];
      dateForm = action.payload.date_from;
      dateTo = action.payload.date_to;
      countDayBetweenTwoDates = getCountDayBetweenTwoDates(dateForm, dateTo);
      if (countDayBetweenTwoDates == 1) {
        dataChart = generateDataSeparationTimeEachHour(
          report.count_view_each_hour
        );
      } else {
        dataChart = generateDataSeparationTime(
          dateForm.split(" ")[0],
          dateTo.split(" ")[0],
          report.count_view_each_hour * 24
        );
        for (const key in dataChart) {
          dataChart[key] = dataChart[key].view;
        }
      }

      newState = {
        ...state,
        active_chart:
          helpersTime.getDifferentDates(
            action.payload.date_from,
            action.payload.date_to
          ) == 1
            ? activeChart.LINE_SIMPLE
            : activeChart.BAR,
        data_chart: dataChart,
      };
      break;

    case reportActions.GET_ALL_CAMPAIGN_REPORT_PIE_CHART:
      dateForm = action.payload.date_from;
      dateTo = action.payload.date_to;
      countDayBetweenTwoDates = getCountDayBetweenTwoDates(dateForm, dateTo);
      dataChartSeparation = {};
      ReportData.forEach((report) => {
        if (state.which_separation_active == separationActive.PUBLISHER) {
          report.site_publisher.forEach((sitePublisher) => {
            countView =
              sitePublisher.count_view_each_hour * countDayBetweenTwoDates * 24;

            dataChartSeparation[sitePublisher.url] = {
              view: countView,
              time_view: countView * countDayBetweenTwoDates * 24,
              cost: countDayBetweenTwoDates * report.price_each_day,
            };
          });
        } else if (state.which_separation_active == separationActive.POSITION) {
          report.positions.forEach((position) => {
            countView =
              position.count_view_each_hour * countDayBetweenTwoDates * 24;
            dataChartSeparation[position.tagHtmlID] = {
              view:
                position.count_view_each_hour * countDayBetweenTwoDates * 24,
              time_view: countView * countDayBetweenTwoDates * 24,
              cost: countDayBetweenTwoDates * report.price_each_day,
            };
          });
        } else if (state.which_separation_active == separationActive.TIME) {
          dataChartSeparation = generateDataSeparationTime(
            dateForm.split(" ")[0],
            dateTo.split(" ")[0],
            report.count_view_each_hour * 24
          );
          for (const key in dataChartSeparation) {
            dataChartSeparation[key]["time_view"] =
              dataChartSeparation[key].view * countDayBetweenTwoDates * 24;
            dataChartSeparation[key]["cost"] =
              countDayBetweenTwoDates * report.price_each_day;
          }
        }
      });

      newState = {
        ...state,
        data_chart_separation: dataChartSeparation,
      };

      break;

    case reportActions.GET_CAMPAIGN_REPORT_PIE_CHART:
      campaignID = action.payload.campaign_id;
      report = ReportData.filter((campaign) => campaign.id == campaignID);
      report = report[0];
      dateForm = action.payload.date_from;
      dateTo = action.payload.date_to;
      countDayBetweenTwoDates = getCountDayBetweenTwoDates(dateForm, dateTo);
      dataChartSeparation = {};

      if (state.which_separation_active == separationActive.PUBLISHER) {
        report.site_publisher.forEach((sitePublisher) => {
          countView =
            sitePublisher.count_view_each_hour * countDayBetweenTwoDates * 24;

          dataChartSeparation[sitePublisher.url] = {
            view: countView,
            time_view: countView * countDayBetweenTwoDates * 24,
            cost: countDayBetweenTwoDates * report.price_each_day,
          };
        });
      } else if (state.which_separation_active == separationActive.POSITION) {
        report.positions.forEach((position) => {
          countView =
            position.count_view_each_hour * countDayBetweenTwoDates * 24;
          dataChartSeparation[position.tagHtmlID] = {
            view: position.count_view_each_hour * countDayBetweenTwoDates * 24,
            time_view: countView * countDayBetweenTwoDates * 24,
            cost: countDayBetweenTwoDates * report.price_each_day,
          };
        });
      } else if (state.which_separation_active == separationActive.TIME) {
        dataChartSeparation = generateDataSeparationTime(
          dateForm.split(" ")[0],
          dateTo.split(" ")[0],
          report.count_view_each_hour * 24
        );
        for (const key in dataChartSeparation) {
          dataChartSeparation[key]["time_view"] =
            dataChartSeparation[key].view * countDayBetweenTwoDates * 24;
          dataChartSeparation[key]["cost"] =
            countDayBetweenTwoDates * report.price_each_day;
        }
      }
      newState = {
        ...state,
        data_chart_separation: dataChartSeparation,
      };
      break;

    case reportActions.GET_REPORT_ALL_CAMPAIGN:
      ReportData.forEach((reportCampaign) => {
        countView = getCountViewCampaign(
          action.payload.date_from,
          action.payload.date_to,
          reportCampaign
        );
        allCampaignCountView = allCampaignCountView + countView;
        allCampaignTimeView =
          allCampaignTimeView +
          countView * reportCampaign.max_time_duration_banner;
        allCampaignCost =
          allCampaignCost +
          getCostCampaign(
            action.payload.date_from,
            action.payload.date_to,
            reportCampaign.price_each_day
          );
      });

      newState = {
        ...state,
        count_active_campaign: 4,
        which_type_select:
          constantsReportCampaign.whichTypeSelect.TYPE_CAMPAIGNS,

        count_view: allCampaignCountView,
        time_view_campaign: allCampaignTimeView,
        price: allCampaignCost,
      };
      break;

    case reportActions.SET_DATE_REPORT_FILTER:
      newState = {
        ...state,
        date_from: action.payload.date_from,
        date_to: action.payload.date_to,
      };
      break;

    case reportActions.SET_EVENT_DATA_CHART:
      newState = {
        ...state,
        event_data_chart: action.payload.event_data_chart,
      };
      break;

    case reportActions.SET_TYPE_SEPARATION_DATA_CHART:
      newState = {
        ...state,
        which_separation_active: action.payload.separation,
      };
      break;

    case reportActions.EMPTY_CAMPAIGNS_DATA_SEPARATION_FAILED:
      newState = {
        ...state,
        data_chart_separation: {},
      };
      break;
  }
  return newState;
};
export default main;
